import { Component, OnInit, } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
@Component({
  selector: 'app-omnichannel-pagenotfound',
  templateUrl: './omnichannel-pagenotfound.component.html',
  styleUrls: ['../features.css', './omnichannel-pagenotfound.component.css']
})
export class OmnichannelPageNotFoundComponent extends BaseComponent implements OnInit {
  displayMessage = '';
  override ngOnInit(): void {
    this.displayMessage = 'Page Not Found';
  }
}